module.exports = __webpack_public_path__ + "img/img-ticket-2.f712af33.png";